import { inject } from "@angular/core";
import { GlobalFilterService } from "../../shared/services/global-filter.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadLocations, loadMenuItems, loadMenuItemsSuccess, loadNotifications, locationsLoadSuccess, notificationsLoadSuccess } from "./header.actions";
import { map, switchMap, withLatestFrom } from "rxjs";
import { Router } from "@angular/router";
import { NotificationsService } from "../../shared/services/notifications.service";
import { MenuService } from "../../shared/services/menu.service";
import { Store } from "@ngrx/store";
import * as operatorsActions from './../operators/operators.actions';
import * as operatorsSelectors from './../operators/operators.selectors';
import { OperatorOption } from "./header.models";

export class HeaderEffects {
    actions$: Actions = inject(Actions);
    store: Store = inject(Store)
    router: Router = inject(Router);
    globalFilterService: GlobalFilterService = inject(GlobalFilterService);
    notificationsService: NotificationsService = inject(NotificationsService)
    menuService: MenuService = inject(MenuService);

    triggerLocationLoad$ = createEffect(() =>
        this.actions$.pipe(
            ofType(operatorsActions.SetCurrentOperator),
            withLatestFrom(this.store.select(operatorsSelectors.selectOperators)),
            map(([action, operators]) => {
                const operator = operators.find(x => x.id === action.currentOperatorId);
                const operatorOption = { id: operator?.id, name: operator?.name } as OperatorOption
                return loadLocations({ operator: operatorOption })
            })
        )
    );

    loadLocations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadLocations),
            switchMap(({ operator }) =>
                this.globalFilterService.getLocationOptions(operator?.id).pipe(
                    map(res => locationsLoadSuccess({ locations: res }))
                )
            )
        )
    );

    loadNotifications$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadNotifications),
            switchMap(() =>
                this.notificationsService.getNotifications().pipe(
                    map(res => notificationsLoadSuccess({ notifications: res }))
                )
            )
        )
    );

    loadMenuItems$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadMenuItems),
            switchMap(() =>
                this.menuService.getMenuItems().pipe(
                    map(res => loadMenuItemsSuccess({ menuItems: res }))
                )
            )
        )
    );
}